import { getInstagramConnection } from "./apf-api.service";

export async function checkInstagramConnection(
  userId: string,
  idToken: string | null
) {
  try {
    const res = await getInstagramConnection(userId, idToken);
    return res.connected ?? false;
  } catch (err) {
    console.error(err);
    return false;
  }
}

export async function startInstagramConnect(
  userId: string,
  idToken: string | null
) {
  window.location.href = `${process.env.REACT_APP_API_URL}/api/social/instagram/connect?userId=${encodeURIComponent(
    userId
  )}`;
}

export async function getInstagramMetrics(userId: string) {
  // const res = await fetch(
  //   `${API_URL}/api/social/instagram/metrics?userId=${encodeURIComponent(
  //     userId
  //   )}`
  // );
  // if (!res.ok) throw new Error(`Error ${res.status}`);
  // return res.json();

  return [
    {
      id: "1",
      username: "apfome",
      name: "Apfome",
      profile_picture_url:
        "https://www.apfome.com/assets/images/apfome-logo/logo-90.png",
      metrics: {
        followers: { value: 12500, mom: 5.4, yoy: 12.2 },
        reach: { value: 40200, mom: -2.1, yoy: 8.5 },
        impressions: { value: 150300, mom: 3.8, yoy: 10.1 },
        engagement: { value: 4.2, mom: 0.5, yoy: 1.1 },
        posts: { value: 320, mom: 1.2, yoy: 6.7 },
      },
      topPosts: [
        {
          id: "p1",
          thumbnail:
            "https://images.unsplash.com/photo-1654554515865-dc1fc2d2748c?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          likes: 1200,
          comments: 56,
          saves: 42,
          caption: "Launch day!",
        },
        {
          id: "p2",
          thumbnail:
            "https://images.unsplash.com/photo-1696332415657-9fbe802a8875?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          likes: 980,
          comments: 40,
          saves: 33,
          caption: "Behind the scenes",
        },
        {
          id: "p3",
          thumbnail:
            "https://images.unsplash.com/photo-1556741576-1d17b478d761?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          likes: 860,
          comments: 28,
          saves: 25,
          caption: "Customer story",
        },
      ],
      insights: [
        "Engagement improved despite a slight drop in reach — your core audience is interacting more strongly.",
        "Follower growth outpaces industry benchmarks this month.",
        "Consider boosting posts to expand reach and maintain engagement momentum.",
      ],
    },
    {
      id: "2",
      username: "web3dma",
      name: "web3dma",
      profile_picture_url: "/web3.png",
      metrics: {
        followers: { value: 8450, mom: 2.2, yoy: 9.4 },
        reach: { value: 30900, mom: -1.5, yoy: 7.8 },
        impressions: { value: 110250, mom: 4.9, yoy: 11.6 },
        engagement: { value: 3.8, mom: 0.3, yoy: 0.9 },
        posts: { value: 215, mom: 0.9, yoy: 5.2 },
      },
      topPosts: [
        {
          id: "p4",
          thumbnail:
            "https://images.unsplash.com/photo-1523275335684-37898b6baf30?q=80&w=1999&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          likes: 730,
          comments: 22,
          saves: 15,
          caption: "Product highlight",
        },
        {
          id: "p5",
          thumbnail:
            "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          likes: 690,
          comments: 18,
          saves: 12,
          caption: "Event recap",
        },
        {
          id: "p6",
          thumbnail:
            "https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          likes: 640,
          comments: 20,
          saves: 10,
          caption: "Team shoutout",
        },
      ],
      insights: [
        "Reach dipped slightly but impressions are climbing — consistency is paying off.",
        "Your follower growth is steady but below Brand One — opportunity to increase posting frequency.",
      ],
    },
  ];
}
